<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomUploader
          :value="formData.photo"
          :on-change="(value) => onChange('photo', value)"
          label="Фотография"
          :fullWidth="true"
        />
      </div>
      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomUploader from "@/components/form/CustomUploader";

export default {
  name: "add-contractor-works-photo",
  components: { CustomModalFooter, CustomUploader },
  props: ["data"],
  data() {
    return {
      btnLoading: false,
      formData: {
        photo: "",
        contractor_id: this.data?.contractor_id || "",
      },
    };
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.btnLoading = true;
      if (this.formData.photo) {
        this.formData.photo = this.formData.photo[0];
      }
      await this.data?.onSubmit(this.formData);
      this.btnLoading = false;
    },
  },
};
</script>

